import { FC } from "react";

import { ModalButton } from "../../types";

import { useForm } from "../../app/useForm";
import { SlideOverWrapper } from "../../../ui/layout/organisms/SlideOver/SlideOverWrapper/SlideOverWrapper";
import { VoidBooleanPromise } from "../../../helpers/functions/types";

type SlideOverFormProps = {
  open: boolean;
  title?: string;
  subtitle?: string;
  onAccept?: VoidBooleanPromise;
  onClose: () => void;
  acceptText?: string;
  declineText?: string;
  valid?: boolean;
  acceptButton?: ModalButton;
};

export const SlideOverForm: FC<React.PropsWithChildren<SlideOverFormProps>> = ({
  open,
  title,
  subtitle,
  onAccept,
  onClose,
  children,
  declineText,
  valid = true,
  acceptButton,
}) => {
  const { handleFormAccept } = useForm();
  return (
    <SlideOverWrapper
      open={open}
      onClose={onClose}
      title={title ?? subtitle ?? ""}
      declineText={declineText}
      customFooter={acceptButton && acceptButton?.length !== 1}
      buttonProps={
        acceptButton
          ? {
              onClick: () => handleFormAccept(acceptButton.action),
              title: acceptButton.label,
              buttonType:
                acceptButton.style?.background_color === "red"
                  ? "danger"
                  : "primary",
              disabled: !valid,
            }
          : onAccept
            ? { onClick: onAccept }
            : undefined
      }
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (onAccept) onAccept();
        }}
      >
        {children}
      </form>
    </SlideOverWrapper>
  );
};
